const $ = jQuery.noConflict();

class StepCards {
    constructor() {
        this.card = '.block-step-cards__card';
        this.more = '.block-step-cards__card-more';
    }

    init() {
        this.scroll();
        this.hover();
        this.expandDescription();
    }

    hover() {
        $(this.card).on('mouseenter', event => {
            const card = $(event.currentTarget);
            card.addClass('active').prevAll().addClass('active');
        });

        $(this.card).on('mouseleave', event => {
            //const card = $(event.currentTarget);
            //card.parent().find(`${this.card}:not(:first-child)`).removeClass('active');
            this.scroll();
        });
    }

    scroll() {
        $(this.card).each((index, el) => {
            const topOfElement = $(el).offset().top;
            const bottomOfElement = $(el).offset().top + $(el).outerHeight();

            const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight() - ($(window).innerHeight() / 2);
            const topOfScreen = $(window).scrollTop() + ($(window).innerHeight() / 2);

            if ((bottomOfScreen > topOfElement) && (topOfScreen < bottomOfElement)) {
                $(el).addClass('active').prevAll().addClass('active');
                $(el).nextAll().removeClass('active');
            }
        });
    }

    expandDescription() {
        $(this.more).on('click', event => {
            $(event.currentTarget).fadeOut(100);
            setTimeout(() => {
                $(event.currentTarget).next().slideDown(200);
            }, 100);
        });
    }
}

export default new StepCards();
